export function isBadCommit(currentCommit: string, badCommits: string | undefined) {
  return Boolean(
    badCommits &&
      badCommits
        .split(/;|,/)
        .map((commit) => commit.trim())
        .some((commit) => commit && (commit.startsWith(currentCommit) || currentCommit.startsWith(commit))),
  );
}
